"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var style_utils_1 = require("@nef/style-utils");
var Sidebar_1 = require("../../../Sidebar");
var SidebarPopoverHeader_1 = __importDefault(require("../SidebarPopoverHeader"));
var SidebarButtonHeader = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    var expanded = react_1.default.useContext(Sidebar_1.SidebarContext).expanded;
    if (!expanded) {
        return (react_1.default.createElement(SidebarPopoverHeader_1.default, __assign({ className: style_utils_1.classNames("sidebar--popover-header", className) }, props)));
    }
    return null;
};
exports.default = SidebarButtonHeader;
//# sourceMappingURL=index.js.map